import { render, staticRenderFns } from "./TrainingRolePaths.vue?vue&type=template&id=2bcfae96&scoped=true"
import script from "./TrainingRolePaths.vue?vue&type=script&lang=js"
export * from "./TrainingRolePaths.vue?vue&type=script&lang=js"
import style0 from "./TrainingRolePaths.vue?vue&type=style&index=0&id=2bcfae96&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2bcfae96",
  null
  
)

export default component.exports